<template>
  <el-tooltip class="item" effect="dark" :content="'刷新' + viewType" placement="top">
    <i v-if="refreshLoading === false" style="cursor: pointer;" class="el-icon-refresh" @click="handleRefresh"></i>
    <i v-else class="el-icon-loading"></i>
  </el-tooltip>
</template>

<script>
export default {
  name: 'UploadTaskViewRefresh',
  components: {},
  props: {
    viewType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      refreshLoading: false
    }
  },
  methods: {
    handleRefresh () {
      this.refreshLoading = true
      this.$axios.post('/api/admin/upload_tasks_info/view_refresh', { type: this.viewType }, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.refreshLoading = false
          }
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/intellectual_property/common/UploadTaskViewRefresh.vue